import { route } from "quasar/wrappers";
import {
  createRouter,
  createMemoryHistory,
  createWebHistory,
  createWebHashHistory,
} from "vue-router";
import routes from "./routes";
import { bff } from "boot/bff-client";
import { useAuthStore } from "stores/auth";

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default route(function ({ store /*, ssrContext */ }) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : process.env.VUE_ROUTER_MODE === "history"
      ? createWebHistory
      : createWebHashHistory;

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.VUE_ROUTER_BASE),
  });

  Router.beforeEach(async (to, from) => {
    const authStore = useAuthStore();

    if (to.path === "/logout") {
      await bff.auth.logout();
      authStore.reset();
      return { name: "authentication" };
    }

    if (to.path !== "/auth" && !authStore.isBffAuthenticated) {
      await bff.auth.reloadCredentials();
    }

    if (to.meta.requiresAuth && !authStore.isAuthenticated) {
      // need to login if not already logged in
      return { name: "authentication", query: { redirect: to.fullPath } };
    }

    if (to.path === "/auth" && authStore.isAuthenticated) {
      return { name: "Home" };
    }
  });

  return Router;
});
